<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<template>
  <!-- Skip links for keyboard navigation -->
  <nav class="sr-only focus-within:not-sr-only" aria-label="Skip navigation">
    <a
      href="#main-content"
      class="skip-link absolute top-0 left-0 z-50 bg-mint-600 text-white px-4 py-2 rounded-br-lg transform -translate-y-full focus:translate-y-0 transition-transform duration-200"
    >
      {{ t('accessibility.skipToContent') || 'Skip to main content' }}
    </a>
    <a
      href="#navigation"
      class="skip-link absolute top-0 left-0 z-50 bg-mint-600 text-white px-4 py-2 rounded-br-lg transform -translate-y-full focus:translate-y-0 transition-transform duration-200 ml-40"
    >
      {{ t('accessibility.skipToNavigation') || 'Skip to navigation' }}
    </a>
  </nav>
</template>

<style scoped>
.skip-link:focus {
  outline: 2px solid #ffffff;
  outline-offset: 2px;
}

/* Screen reader only class */
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
